import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { OperationSequenceDto } from "./operation-sequence-dto";

export class OperationSequenceResponse extends GlobalResponseObject{
    data?: OperationSequenceDto ;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: OperationSequenceDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 